/**
 * Párrafo item
 * @param {*} editor
 */
function p(editor) {
  const cm = editor.codemirror;
  const selectedText = cm.getSelection();
  const text = selectedText;

  const output = `/p/${text}/p/`;
  cm.replaceSelection(output);
}

export default function () {
  const option = {
    name: 'P',
    action: p,
    className: 'fa fa-paragraph',
    title: 'P',
  };

  return option;
}
